module.exports = __webpack_public_path__ + "img/website.eda837c6.svg";